/**
 * 这个文件作为组件的目录
 * 目的是统一管理对外输出的组件，方便分类
 */
/**
 * 布局组件
 */

import { AvatarName, Question, SelectLang, ThemeToggle } from '@zhiyue/core';

import {
  AiAssistantTrigger,
  AiAssistantWorkspace,
  AiInvestmentManagerSummary,
  AiManagerSummary,
  AiWorkbenchHighlights,
} from './AiAssistant';
import { AiWorkQueue } from './AiAssistant/AiWorkQueue';
import AvatarDropdown from './AvatarDropdown';
import Footer from './Footer';
import { ChangelogTrigger } from './SystemChangelog/ChangelogTrigger';

export {
  AvatarDropdown,
  ChangelogTrigger,
  AvatarName,
  AiAssistantTrigger,
  AiAssistantWorkspace,
  AiManagerSummary,
  AiInvestmentManagerSummary,
  AiWorkbenchHighlights,
  AiWorkQueue,
  Footer,
  Question,
  SelectLang,
  ThemeToggle,
};
